import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
	public questionGroups = [];

	constructor() {
	} 
	
	setQuestions (questions) {
		this.questionGroups = questions;
	}
	
	getQuestionGroupCount () {
		return this.questionGroups.length;
	}
	
	getQuestionGroup (index) {
		return this.questionGroups[index];
	}
}
